import { Component, EventEmitter, Output, Input, Renderer2, ViewChild, ContentChildren, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgForm, FormsModule } from '@angular/forms';

/**
 * @fileoverview added by tsickle
 * Generated from: lib/stepset/stepset.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["progressbar"];
const _c1 = ["bar"];
function StepsetComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 22);
    ɵngcc0.ɵɵlistener("click", function StepsetComponent_div_3_Template_div_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const i_r6 = ctx.index; const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.jumpToStep(i_r6); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const s_r5 = ctx.$implicit;
    const i_r6 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", i_r6 < ctx_r0.stepNo ? "validStep" : "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", i_r6 + 1, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(s_r5.title);
} }
function StepsetComponent_button_25_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 23);
    ɵngcc0.ɵɵlistener("click", function StepsetComponent_button_25_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.nextStep(); });
    ɵngcc0.ɵɵtext(1, "Next");
    ɵngcc0.ɵɵelementEnd();
} }
function StepsetComponent_button_26_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 24);
    ɵngcc0.ɵɵlistener("click", function StepsetComponent_button_26_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.submit(); });
    ɵngcc0.ɵɵtext(1, "Finish");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngStyle", ctx_r4.styles);
} }
const _c2 = function (a0) { return { "transform": a0 }; };
const _c3 = ["*"];
function StepComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "h5", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵprojection(3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.active ? "slide" : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.title);
} }
class StepsetComponent {
    /**
     * @param {?} rd
     */
    constructor(rd) {
        this.rd = rd;
        this.steps = [];
        this.stepNo = 0;
        this.totalSteps = 0;
        this.btnPos = 'btn-left';
        this.next = new EventEmitter();
        this.submitEvent = new EventEmitter();
        this.radius = 35;
        this.strokeDashOffset = Math.PI * 2 * this.radius;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.steps[0].active = true;
    }
    /**
     * @param {?} step
     * @return {?}
     */
    addStep(step) {
        this.totalSteps = this.steps.push(step);
    }
    /**
     * @param {?} i
     * @return {?}
     */
    jumpToStep(i) {
        if (this.steps[i > 0 ? i - 1 : i].valid) {
            this.stepNo = i;
            this.setActiveStep(this.stepNo);
        }
    }
    /**
     * @return {?}
     */
    nextStep() {
        if (this.steps[this.stepNo].form[0]['valid']) {
            this.steps[this.stepNo].valid = true;
            this.stepNo < this.totalSteps ? this.setActiveStep(++this.stepNo) : null;
            this.next.emit(this.steps[this.stepNo].valid);
        }
    }
    /**
     * @return {?}
     */
    setProgressbarColor() {
        this.progressValue = Math.floor(100 / (this.totalSteps - 1)) * this.stepNo - 100;
        this.rd.setStyle(this.circularBar.nativeElement, 'stroke-dashoffset', ((100 - this.progressValue) / 100) * (Math.PI * (2 * this.radius)) - this.strokeDashOffset);
    }
    /**
     * @return {?}
     */
    prevStep() {
        this.stepNo > 0 ? this.setActiveStep(--this.stepNo) : null;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    setActiveStep(index) {
        this.setProgressbarColor();
        this.steps.forEach((/**
         * @param {?} s
         * @return {?}
         */
        s => {
            s.active = false;
        }));
        this.steps[index].active = true;
    }
    /**
     * @return {?}
     */
    submit() {
        this.submitEvent.emit(true);
    }
}
StepsetComponent.ɵfac = function StepsetComponent_Factory(t) { return new (t || StepsetComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
StepsetComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StepsetComponent, selectors: [["stepset"]], viewQuery: function StepsetComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 1);
        ɵngcc0.ɵɵviewQuery(_c1, 1);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.progressbar = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.circularBar = _t.first);
    } }, inputs: { btnPos: "btnPos", styles: ["finishBtn", "styles"] }, outputs: { next: "next", submitEvent: "submitEvent" }, ngContentSelectors: _c3, decls: 27, vars: 15, consts: [["id", "stepset-container"], ["id", "lg-progress"], ["id", "step-nav"], [3, "ngClass", "click", 4, "ngFor", "ngForOf"], ["id", "line-progress", "height", "7"], ["id", "progress-container"], ["x1", "0", "y1", "50%", "x2", "100%", "y2", "50%", "stroke-width", "7"], ["id", "progress-content"], ["x1", "0", "y1", "50%", "x2", "100%", "y2", "50%", "stroke-width", "7", "fill", "transparent", "stroke-dasharray", "0%", "stroke-dashoffset", "0%", 3, "ngStyle"], ["progressbar", ""], ["id", "xs-progress"], [1, "step-display"], ["id", "svg", "width", "100", "height", "100"], ["cx", "50", "cy", "50", "fill", "transparent", "stroke-dashoffset", "0"], ["id", "bar", "cx", "50", "cy", "50", "fill", "transparent"], ["bar", ""], [1, "title"], ["id", "content-container"], ["id", "buttons", 3, "ngClass"], [1, "prev-btn", 3, "click"], ["class", "next-btn", 3, "click", 4, "ngIf"], [3, "ngStyle", "click", 4, "ngIf"], [3, "ngClass", "click"], [1, "next-btn", 3, "click"], [3, "ngStyle", "click"]], template: function StepsetComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, StepsetComponent_div_3_Template, 4, 3, "div", 3);
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(4, "svg", 4);
        ɵngcc0.ɵɵelementStart(5, "g", 5);
        ɵngcc0.ɵɵelement(6, "line", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "g", 7);
        ɵngcc0.ɵɵelement(8, "line", 8, 9);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(10, "div", 10);
        ɵngcc0.ɵɵelementStart(11, "span", 11);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(13, "svg", 12);
        ɵngcc0.ɵɵelement(14, "circle", 13);
        ɵngcc0.ɵɵelement(15, "circle", 14, 15);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(17, "h3", 16);
        ɵngcc0.ɵɵtext(18);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 17);
        ɵngcc0.ɵɵprojection(20);
        ɵngcc0.ɵɵelement(21, "hr");
        ɵngcc0.ɵɵelementStart(22, "div", 18);
        ɵngcc0.ɵɵelementStart(23, "button", 19);
        ɵngcc0.ɵɵlistener("click", function StepsetComponent_Template_button_click_23_listener() { return ctx.prevStep(); });
        ɵngcc0.ɵɵtext(24, "Back");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(25, StepsetComponent_button_25_Template, 2, 0, "button", 20);
        ɵngcc0.ɵɵtemplate(26, StepsetComponent_button_26_Template, 2, 1, "button", 21);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.steps);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(13, _c2, "translateX(" + ctx.progressValue + "%)"));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate2("", ctx.stepNo + 1, " of ", ctx.totalSteps, "");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵattribute("r", ctx.radius)("stroke-dasharray", ctx.strokeDashOffset);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("r", ctx.radius)("stroke-dasharray", ctx.strokeDashOffset)("stroke-dashoffset", ctx.strokeDashOffset);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate1(" ", ctx.steps[ctx.stepNo] == null ? null : ctx.steps[ctx.stepNo].title, " ");
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngClass", ctx.btnPos);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalSteps > ctx.stepNo + 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.totalSteps == ctx.stepNo + 1);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgStyle, ɵngcc1.NgClass, ɵngcc1.NgIf], styles: ["#stepset-container[_ngcontent-%COMP%]{padding:10px;box-shadow:0 0 5px rgba(0,0,0,.2);margin:20px;border-radius:4px}#buttons[_ngcontent-%COMP%]{margin-top:20px;position:relative;display:-webkit-box;display:flex}#buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{font-size:1.1em;border:1px solid #ccc;background:#fff;border-radius:4px;padding:10px 15px;margin-right:10px;box-shadow:2px 4px 5px rgba(0,0,0,.2)}#buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:focus{outline:0}#buttons[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]:hover{background-color:#f7f7f7}.btn-left[_ngcontent-%COMP%]{-webkit-box-pack:left;justify-content:left}.btn-apart[_ngcontent-%COMP%]{-webkit-box-pack:justify;justify-content:space-between}.btn-right[_ngcontent-%COMP%]{-webkit-box-pack:end;justify-content:flex-end}.btn-center[_ngcontent-%COMP%]{-webkit-box-pack:center;justify-content:center}.left[_ngcontent-%COMP%]{text-align:left}.right[_ngcontent-%COMP%]{text-align:right}.center[_ngcontent-%COMP%]{text-align:center}#step-nav[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;position:relative}#step-nav[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{line-height:1.4;padding-top:6px;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}#step-nav[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{cursor:pointer;display:inline-block;width:40px;height:40px;line-height:3;text-align:center;border-radius:50%;z-index:1;background:#ccc;position:relative;color:#7e7b7b}#step-nav[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:after, #step-nav[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:before{position:absolute;left:0;top:0;display:inline-block;border-radius:50%}#step-nav[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:after{content:\"\";width:50px;height:50px;background-color:transparent;border:6px solid #fff;-webkit-transform:translate(-10%,-10%);transform:translate(-10%,-10%)}#step-nav[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]:before{content:\"\\2713\";width:inherit;background-color:#1b9e0b;color:#fff;opacity:0;-webkit-transition:opacity 1s;transition:opacity 1s}#step-nav[_ngcontent-%COMP%]   div.validStep[_ngcontent-%COMP%]:before{opacity:1}#progress-container[_ngcontent-%COMP%]{stroke:#ccc}#progress-content[_ngcontent-%COMP%]{stroke:green}#progress-content[_ngcontent-%COMP%]   line[_ngcontent-%COMP%]{-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-transition:.6s cubic-bezier(.39,.575,.565,1);transition:.6s cubic-bezier(.39,.575,.565,1)}#line-progress[_ngcontent-%COMP%]{position:absolute;width:100%;top:16px}#svg[_ngcontent-%COMP%]{stroke-dashoffset:0;stroke:#ccc;stroke-width:5px}#svg[_ngcontent-%COMP%]   #bar[_ngcontent-%COMP%]{stroke:green;-webkit-transition:stroke-dashoffset 1s;transition:stroke-dashoffset 1s}.title[_ngcontent-%COMP%]{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-flow:column;margin-left:18px;font-size:1.5em;line-height:1.2}#content-container[_ngcontent-%COMP%]{padding:10px}.step-display[_ngcontent-%COMP%]{position:absolute;-webkit-transform:translate(100%,200%);transform:translate(100%,200%);left:-1%}@media (min-width:768px){#content-container[_ngcontent-%COMP%]{padding:20px 30px;margin-top:40px}#xs-progress[_ngcontent-%COMP%]{display:none}#lg-progress[_ngcontent-%COMP%]{display:block;padding:10px 35px}}@media (max-width:426px){#xs-progress[_ngcontent-%COMP%]{display:inline-block;position:relative;display:-webkit-box;display:flex}#lg-progress[_ngcontent-%COMP%]{display:none}}"] });
/** @nocollapse */
StepsetComponent.ctorParameters = () => [
    { type: Renderer2 }
];
StepsetComponent.propDecorators = {
    progressbar: [{ type: ViewChild, args: ['progressbar',] }],
    styles: [{ type: Input, args: ['finishBtn',] }],
    btnPos: [{ type: Input, args: ['btnPos',] }],
    next: [{ type: Output }],
    circularBar: [{ type: ViewChild, args: ['bar',] }],
    submitEvent: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepsetComponent, [{
        type: Component,
        args: [{
                selector: 'stepset',
                template: "<div id=\"stepset-container\">\n  <div id=\"lg-progress\">\n    <div id=\"step-nav\">\n      <div *ngFor=\"let s of steps;let i=index\" (click)=\"jumpToStep(i)\" [ngClass]=\"i < stepNo ? 'validStep' : ''\">\n        {{i+1}}<p>{{s.title}}</p>\n      </div>\n      <svg id=\"line-progress\" height=7>\n        <g id=\"progress-container\">\n          <line x1=\"0\" y1=\"50%\" x2=\"100%\" y2=\"50%\" stroke-width=7 />\n        </g>\n        <g id=\"progress-content\">\n          <line x1=\"0\" y1=\"50%\" x2=\"100%\" y2=\"50%\" stroke-width=7 fill=\"transparent\" stroke-dasharray=\"0%\"\n            stroke-dashoffset=\"0%\" #progressbar [ngStyle]=\"{'transform':'translateX('+ progressValue +'%)'}\" />\n        </g>\n      </svg>\n    </div>\n  </div>\n\n  <div id=\"xs-progress\">\n    <span class=\"step-display\">{{this.stepNo+1}} of {{this.totalSteps}}</span>\n    <svg id=\"svg\" width=\"100\" height=\"100\">\n      <circle [attr.r]='radius' cx=\"50\" cy=\"50\" fill=\"transparent\" [attr.stroke-dasharray]=\"strokeDashOffset\"\n        stroke-dashoffset=\"0\"></circle>\n      <circle #bar id=\"bar\" [attr.r]='radius' cx=\"50\" cy=\"50\" fill=\"transparent\"\n        [attr.stroke-dasharray]=\"strokeDashOffset\" [attr.stroke-dashoffset]='strokeDashOffset'></circle>\n    </svg>\n    <h3 class=\"title\">\n      {{steps[stepNo]?.title}}\n    </h3>\n  </div>\n  <div id=\"content-container\">\n    <ng-content></ng-content>\n    <hr>\n    <div id=\"buttons\" [ngClass]=\"btnPos\">\n      <button class=\"prev-btn\" (click)=\"prevStep()\">Back</button>\n      <button class=\"next-btn\" (click)=\"nextStep()\" *ngIf=\"totalSteps > stepNo+1\">Next</button>\n      <button (click)=\"submit()\" [ngStyle]=\"styles\" *ngIf=\"totalSteps == stepNo+1\">Finish</button>\n    </div>\n  </div>\n</div>",
                styles: ["#stepset-container{padding:10px;box-shadow:0 0 5px rgba(0,0,0,.2);margin:20px;border-radius:4px}#buttons{margin-top:20px;position:relative;display:-webkit-box;display:flex}#buttons button{font-size:1.1em;border:1px solid #ccc;background:#fff;border-radius:4px;padding:10px 15px;margin-right:10px;box-shadow:2px 4px 5px rgba(0,0,0,.2)}#buttons button:focus{outline:0}#buttons button:hover{background-color:#f7f7f7}.btn-left{-webkit-box-pack:left;justify-content:left}.btn-apart{-webkit-box-pack:justify;justify-content:space-between}.btn-right{-webkit-box-pack:end;justify-content:flex-end}.btn-center{-webkit-box-pack:center;justify-content:center}.left{text-align:left}.right{text-align:right}.center{text-align:center}#step-nav{display:-webkit-box;display:flex;-webkit-box-pack:justify;justify-content:space-between;position:relative}#step-nav p{line-height:1.4;padding-top:6px;display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center}#step-nav div{cursor:pointer;display:inline-block;width:40px;height:40px;line-height:3;text-align:center;border-radius:50%;z-index:1;background:#ccc;position:relative;color:#7e7b7b}#step-nav div:after,#step-nav div:before{position:absolute;left:0;top:0;display:inline-block;border-radius:50%}#step-nav div:after{content:\"\";width:50px;height:50px;background-color:transparent;border:6px solid #fff;-webkit-transform:translate(-10%,-10%);transform:translate(-10%,-10%)}#step-nav div:before{content:\"\\2713\";width:inherit;background-color:#1b9e0b;color:#fff;opacity:0;-webkit-transition:opacity 1s;transition:opacity 1s}#step-nav div.validStep:before{opacity:1}#progress-container{stroke:#ccc}#progress-content{stroke:green}#progress-content line{-webkit-transform:translateX(-100%);transform:translateX(-100%);-webkit-transition:.6s cubic-bezier(.39,.575,.565,1);transition:.6s cubic-bezier(.39,.575,.565,1)}#line-progress{position:absolute;width:100%;top:16px}#svg{stroke-dashoffset:0;stroke:#ccc;stroke-width:5px}#svg #bar{stroke:green;-webkit-transition:stroke-dashoffset 1s;transition:stroke-dashoffset 1s}.title{display:-webkit-box;display:flex;-webkit-box-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;flex-flow:column;margin-left:18px;font-size:1.5em;line-height:1.2}#content-container{padding:10px}.step-display{position:absolute;-webkit-transform:translate(100%,200%);transform:translate(100%,200%);left:-1%}@media (min-width:768px){#content-container{padding:20px 30px;margin-top:40px}#xs-progress{display:none}#lg-progress{display:block;padding:10px 35px}}@media (max-width:426px){#xs-progress{display:inline-block;position:relative;display:-webkit-box;display:flex}#lg-progress{display:none}}"]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { btnPos: [{
            type: Input,
            args: ['btnPos']
        }], next: [{
            type: Output
        }], submitEvent: [{
            type: Output
        }], progressbar: [{
            type: ViewChild,
            args: ['progressbar']
        }], styles: [{
            type: Input,
            args: ['finishBtn']
        }], circularBar: [{
            type: ViewChild,
            args: ['bar']
        }] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/stepset/step/step.component.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepComponent {
    /**
     * @param {?} stepset
     */
    constructor(stepset) {
        this.stepset = stepset;
        this.active = false;
        this.valid = false;
    }
    /**
     * @return {?}
     */
    ngOnInit() {
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this.form = this.form.toArray();
        this.stepset.addStep(this);
    }
}
StepComponent.ɵfac = function StepComponent_Factory(t) { return new (t || StepComponent)(ɵngcc0.ɵɵdirectiveInject(StepsetComponent)); };
StepComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: StepComponent, selectors: [["step"]], contentQueries: function StepComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgForm, 0);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.form = _t);
    } }, inputs: { title: "title" }, ngContentSelectors: _c3, decls: 1, vars: 1, consts: [[3, "ngClass", 4, "ngIf"], [3, "ngClass"], [1, "title"]], template: function StepComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, StepComponent_div_0_Template, 4, 2, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.active);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], styles: ["[_nghost-%COMP%]{width:100%}.slide[_ngcontent-%COMP%]{-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-animation:.5s forwards animateStep;animation:.5s forwards animateStep}@-webkit-keyframes animateStep{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes animateStep{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}.title[_ngcontent-%COMP%]{font-size:1.5em;margin-bottom:15px}@media (max-width:426px){.title[_ngcontent-%COMP%]{display:none}}"] });
/** @nocollapse */
StepComponent.ctorParameters = () => [
    { type: StepsetComponent }
];
StepComponent.propDecorators = {
    title: [{ type: Input }],
    form: [{ type: ContentChildren, args: [NgForm,] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepComponent, [{
        type: Component,
        args: [{
                selector: 'step',
                template: "<div *ngIf=\"active\" [ngClass]=\"active ? 'slide' : ''\">\n    <h5 class=\"title\">{{title}}</h5>\n    <ng-content></ng-content>\n</div>",
                styles: [":host{width:100%}.slide{-webkit-transform:translateX(100%);transform:translateX(100%);-webkit-animation:.5s forwards animateStep;animation:.5s forwards animateStep}@-webkit-keyframes animateStep{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}@keyframes animateStep{0%{-webkit-transform:translateX(100%);transform:translateX(100%)}100%{-webkit-transform:translateX(0);transform:translateX(0)}}.title{font-size:1.5em;margin-bottom:15px}@media (max-width:426px){.title{display:none}}"]
            }]
    }], function () { return [{ type: StepsetComponent }]; }, { form: [{
            type: ContentChildren,
            args: [NgForm]
        }], title: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * Generated from: lib/stepset/stepset.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class StepsetModule {
}
StepsetModule.ɵfac = function StepsetModule_Factory(t) { return new (t || StepsetModule)(); };
StepsetModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: StepsetModule });
StepsetModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule, FormsModule]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StepsetModule, { declarations: function () { return [StepsetComponent, StepComponent]; }, imports: function () { return [CommonModule, FormsModule]; }, exports: function () { return [StepComponent, StepsetComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepsetModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, FormsModule],
                declarations: [StepsetComponent, StepComponent],
                exports: [StepComponent, StepsetComponent]
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * Generated from: public_api.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * Generated from: stepper-library.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { StepsetComponent, StepComponent, StepsetModule };

//# sourceMappingURL=stepper-library.js.map